/**
 * Mail Merge for Gmail - Mailmeteor
 *
 * Its single web-accessible-resource entry exposes `assets/img/`, `assets/fonts/` and
 * `assets/videos/` — but only to `https://mail.google.com` (no `use_dynamic_url`). So
 * the resources are static and fetchable at a fixed URL, yet only Gmail can reach them:
 * from any other origin the fetch fails and a negative proves nothing.
 *
 * We probe the vendor-named `assets/img/mailmeteor-128x128.png`, which the manifest
 * exposes to that origin.
 *
 * Manifest verified against version 2.19.2.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'loclkojldkjladfhbngilnhbeffbkgdm';

export const mailMergeMailmeteor: ExtensionDefinition = {
  id: ID,
  name: 'Mail Merge for Gmail - Mailmeteor',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 60_000,
  requiredOrigin: 'https://mail.google.com',
  notes:
    'Static WAR scoped to mail.google.com, so only Gmail can detect it — a negative ' +
    'from anywhere else is inconclusive. Vendor-named mailmeteor icons make it conclusive there.',
  signals: [
    {
      id: 'war-mailmeteor-icon-128',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/img/mailmeteor-128x128.png — a vendor-named icon, static but ' +
        'only exposed to mail.google.com.',
      weight: 1,
      run: () => probeFetch(ID, 'assets/img/mailmeteor-128x128.png'),
    },
    {
      id: 'war-mailmeteor-icon-256',
      kind: 'web-accessible-resource',
      description:
        'Fetch assets/img/mailmeteor-256x256.png — a second vendor-named icon, ' +
        'corroborating without leaving the required origin.',
      weight: 0.5,
      run: () => probeFetch(ID, 'assets/img/mailmeteor-256x256.png'),
    },
  ],
};
